<template>
   <v-row class="mt-1">
      <v-col cols="12">
         <v-card>
           <div class=" mb-10" style="background-color: #1D2E4B;">
               <div class="mx-auto" style="width: 90%;">
                   <v-row>
                       <v-col cols="12">
                           <div class="my-12 mt-0">
                              <v-btn dark text @click="$router.push({ name:'Tocas' })"
                              style="float: right;"
                              >
                                 <v-icon
                                   right
                                   dark
                                   class="mr-1"
                                 >
                                   mdi-arrow-left
                                 </v-icon>
                                 Regresar
                               </v-btn>
                               <h1
                                 v-if="apelacion"
                                 class="white--text text-center pb-3 pt-10 text-h3"
                               >
                                 TOCA {{ apelacion.toca.numero }}/{{ apelacion.toca.anio }}
                                 <span v-if=" apelacion.toca.complemento">
                                    -{{  apelacion.toca.complemento }}
                                 </span>
                               </h1>
                               <div
                                   class="ul-invoice-v1-header d-flex flex-wrap justify-center align-center"
                               >
                                   <p
                                       class="ma-0 mb-n6 grey--text text--lighten-3 font-weight-medium"
                                   >{{ currentUser.sala.nombre }}
                                   </p>
                               </div>
                               <v-divider dark class="my-12" style="background-color: #CDA74A;"></v-divider>
                           </div>
                           <div
                               class="d-flex justify-space-between flex-wrap py-10 mt-n10 pb-0 pt-3"
                           >
                               <div class="mb-8 d-flex flex-column max-w-xs">
                                   <span
                                       class="white--text font-weight-medium text-18"
                                    >PONENCIA
                                   </span>
                                   <span
                                    v-if="cuenta_detalles"
                                     class="grey--text text--lighten-3 font-weight-medium text-18">
                                     {{ cuenta_detalles.nombre_magistrado }}<br>
                                     <!-- {{ cuenta_detalles.nombre_relator }} -->
                                   </span>
                               </div>
                               <div v-if="cuenta_detalles && cuenta_detalles.sentido_ponencia">
                                    <span
                                        class="white--text font-weight-medium text-18 mr-4"
                                    >SENTIDO:</span>
                                    <span
                                     class="font-weight-medium grey--text text--lighten-3 text-18"
                                     >{{ cuenta_detalles.sentido_ponencia }}</span>
                               </div>
                           </div>
                       </v-col>
                   </v-row>
               </div>
            </div>
            <v-card-text>
               <div class="mx-auto" style="width: 90%;">
                  <v-row>
                     <v-col cols="12" md="12">
                        <p
                            class="font-weight-bold text-18 mb-2"
                            style="color:#616161"
                        >
                            DETALLES DEL TOCA
                        </p>
                        <v-divider class="mt-2 mb-2" style="background-color:#D4B262">
                        </v-divider>
                    </v-col>
                  </v-row>

                   <!--COMPONENTE DETALLES -->
                  <DetallesApelacion
                     v-if="cuenta_detalles"
                     :cuenta="cuenta_detalles"
                     :apelacion="apelacion"
                     :role="roleUser"
                     @closeModal="$router.push({ name:'Tocas' })"
                   >
                  </DetallesApelacion>

                  <v-divider inset></v-divider>

                  <v-row>
                     <v-col cols="12" md="12" class="md:text-right">
                      <!-- Apelación electrónica -->
                        <div class="mt-6" v-if="apelacion && apelacion.hash">
                           <v-expansion-panels  class="mx-n4" flat>
                              <v-expansion-panel>
                                 <v-expansion-panel-header class="text-uppercase">
                                    <template v-slot:default="{ open }">
                                    <v-row no-gutters>
                                      <v-col
                                        cols="12"
                                        class="text--secondary text-left"
                                      >
                                        <v-fade-transition leave-absolute>
                                          <span
                                            v-if="open"
                                            key="0"
                                            style="color:#D81B60"
                                          >
                                          <b>Detalles de la Apelación Electrónica</b>
                                          </span>
                                          <span
                                            v-else
                                            key="1"
                                            style="color:#D81B60"
                                          >
                                          <b>Detalles de la Apelación Electrónica</b>
                                          </span>
                                        </v-fade-transition>
                                      </v-col>
                                    </v-row>
                                    </template>
                                 </v-expansion-panel-header>
                                 <v-expansion-panel-content>
                                    <ApelacionElectronica
                                      :sala_id="currentUser.sala_id"
                                      :hash="apelacion.hash"
                                    ></ApelacionElectronica>
                                 </v-expansion-panel-content>
                             </v-expansion-panel>
                           </v-expansion-panels>
                           <v-divider></v-divider>
                        </div>
                     </v-col>
                  </v-row>

                   <!--COMPONENTE DE FICHA DE PRECUENTA RELATOR-->
                   <v-row class="mt-8">
                       <v-col cols="12" md="12">
                           <p
                               class=" font-weight-bold text-18 mb-2"
                               style="color:#616161"
                           >
                               OBSERVACIONES RELATOR
                           </p>
                           <v-divider inset class="mt-2 mb-2" style="background-color:#D4B262"></v-divider>
                           <span class="font-weight-bold ml-16" v-if="cuenta_detalles">
                                {{ cuenta_detalles.nombre_relator }}
                           </span>
                       </v-col>
                   </v-row>
                   <v-row>
                       <v-col cols="12">

                           <ObservacionRelator
                             v-if="cuenta_detalles && (currentUser.id === cuenta_detalles.relator_id || currentUser.id === cuenta_detalles.magistrado_id)"
                             :item="cuenta_detalles"
                             :role="roleUser"
                           >
                           </ObservacionRelator>

                       </v-col>
                   </v-row>

                    <!--COMPONENTE DE FICHA DE PRECUENTA MAGISTRADO-->
                    <v-row class="mt-8">
                       <v-col cols="12" md="12">
                           <p
                               class=" font-weight-bold text-18 mb-2"
                               style="color:#616161"
                           >
                               OBSERVACIONES Y SENTIDO (MAGISTRADO)

                           </p>
                           <v-divider inset class="mt-2 mb-2" style="background-color:#D4B262"></v-divider>
                       </v-col>
                   </v-row>
                   <v-row>
                       <v-col cols="12">
                         <ObservacionMagistrado
                             v-if="cuenta_detalles && (currentUser.id === cuenta_detalles.relator_id || currentUser.id === cuenta_detalles.magistrado_id)"
                             :item="cuenta_detalles"
                             :role="roleUser"
                           >
                           </ObservacionMagistrado>

                       </v-col>
                   </v-row>
                   <!--TERMINA COMPONENTE DE FICHA DE PRECUENTA RELATOR / MAGISTRADO-->

                   <!--SECCION DE COLEGIADA-->
                   <v-row v-if="cuenta_detalles && cuenta_detalles.status>=42">
                        <v-col cols="12" md="12">
                           <v-divider inset class="mt-2 mb-2"></v-divider>
                           <p
                               class="font-weight-bold text-18 mb-2"
                               style="color:#616161; text-align: center;"
                           >
                               DETALLES DE CUENTA COLEGIADA
                           </p>
                           <v-divider inset class="mt-2 mb-2"></v-divider>
                        </v-col>
                   </v-row>
                   <v-row v-if="cuenta_detalles && cuenta_detalles.sentido_ponencia_id && cuenta_detalles.status>=42">
                       <v-col cols="12" md="6">
                           <div>
                               <p class=" font-weight-bold text-17 text-center" style="color:#1D2E4B">
                                   Sentido
                               </p>
                           </div>
                           <!-- <p class="font-weight-bold text-15 text-center">
                              <span class="font-weight-bold text-15 pink--text">**Debe Registrar el Sentido al Toca</span>
                           </p> -->
                           <p class="font-weight-bold text-18 text-center">
                               <span style="color:green">{{ cuenta_detalles.sentido_ponencia }}</span>
                           </p>
                       </v-col>
                       <v-col cols="12" md="6">
                           <div>
                               <p class=" font-weight-bold text-17 text-center" style="color:#1D2E4B">
                                   Fecha de Colegiada
                                   <span>

                               </span>
                               </p>
                           </div>
                           <p class=" font-weight-bold text-15 text-center" style="color:#1D2E4B">
                               <!-- <span class="font-weight-bold text-15 pink--text">**Debe Registrar la Fecha de la Colegiada</span> -->
                           </p>
                           <p class=" font-weight-bold text-15 text-center"
                              style="color:#1D2E4B">
                               {{ cuenta_detalles.fecha_cuenta | formatDate }}
                           </p>
                       </v-col>
                   </v-row>

                   <v-divider inset class="mt-2 mb-2"></v-divider>

                   <v-row v-if="cuenta_detalles && cuenta_detalles.sentido_ponencia_id && cuenta_detalles.status==45"
                       class="mt-4"
                   >
                       <v-col cols="12" md="6">
                           <div>
                               <p class=" font-weight-bold text-17 text-center" style="color:#1D2E4B">
                                   Fecha Sentencia
                               </p>
                           </div>
                           <p class="font-weight-bold text-18 text-center">
                               <span style="color:green">
                                 {{ cuenta_detalles.fecha_sentencia | formatDate }}
                               </span>
                           </p>
                       </v-col>
                       <v-col cols="12" md="6">
                           <div>
                               <p class=" font-weight-bold text-17 text-center" style="color:#1D2E4B">
                                   Fecha de Baja
                               </p>
                           </div>
                           <p class=" font-weight-bold text-15 text-center"
                              style="color:#1D2E4B">
                               {{ cuenta_detalles.fecha_baja | formatDate }}
                           </p>
                       </v-col>
                       <v-divider inset class="mt-2 mb-2"></v-divider>
                   </v-row>

                   <!--COMPONENTE DE OBSERVACIONES DE COLEGIADA-->
                   <v-row class="mt-8"
                     v-if="cuenta_detalles &&
                           cuenta_detalles.status>=42 &&
                           roleUser == 'magistrado'"
                   >
                      <v-col cols="12" md="12">
                          <div d-flex>
                              <p
                              class=" font-weight-bold text-18 mb-2"
                              style="color:#616161;"
                              >OBSERVACIONES DE CUENTA COLEGIADA
                              </p>
                          </div>
                          <v-divider inset class="mt-2 mb-2" style="background-color:#D4B262">
                          </v-divider>
                      </v-col>
                   </v-row>
                   <v-row
                        v-if="cuenta_detalles &&
                              cuenta_detalles.status>=42 &&
                              roleUser == 'magistrado'"
                        >
                       <v-col cols="12">
                           <ObservacionColegiada
                             v-if="cuenta_detalles"
                             :item="cuenta_detalles"
                             :role="roleUser"
                           >
                           </ObservacionColegiada>
                       </v-col>
                   </v-row>
                   <!--TERMINA COMPONENTE DE OBSERVACIONES DE COLEGIADA-->

                    <!--COMPONENTE DE VOTOS-->
                    <v-row class="mt-8"
                        v-if="cuenta_detalles &&
                              cuenta_detalles.status>=42 &&
                              roleUser == 'magistrado'"
                     >
                       <v-col cols="12" md="12">
                           <p
                              class=" font-weight-bold text-18 mb-2"
                              style="color:#616161;"
                           > VOTOS DE CUENTA COLEGIADA
                           </p>
                           <v-divider inset class="mt-2 mb-2" style="background-color:#D4B262">
                           </v-divider>
                       </v-col>
                    </v-row>
                    <v-row
                        v-if="cuenta_detalles &&
                              cuenta_detalles.status>=42 &&
                              roleUser == 'magistrado'"
                    >
                     <v-col cols="12">
                        <ColegiadaVotos
                          v-if="cuenta_detalles"
                          :item="cuenta_detalles"
                          :role="roleUser"
                        >
                        </ColegiadaVotos>
                     </v-col>
                    </v-row>
                    <!--TERMINA COMPONENTE DE VOTOS-->

                    <!--COMPONENTE PROYECTO RESOLUCION-->
                    <v-row class="mt-8"
                        v-if="cuenta_detalles && cuenta_detalles.status <= 44 && (currentUser.id === cuenta_detalles.relator_id || currentUser.id === cuenta_detalles.magistrado_id)"
                    >
                      <v-col cols="12" md="12">
                          <div d-flex>
                              <p
                              class=" font-weight-bold text-18 mb-2"
                              style="color:#616161;"
                              >PROYECTO DE RESOLUCION
                              </p>
                          </div>
                          <v-divider inset class="mt-2 mb-2" style="background-color:#D4B262">
                          </v-divider>
                      </v-col>
                    </v-row>
                    <v-row class="mb-6"
                        v-if="cuenta_detalles && cuenta_detalles.status <= 44"
                    >
                       <v-col cols="12">
                           <SubirResolucion
                             v-if="cuenta_detalles && cuenta_detalles.status <= 44 && (currentUser.id === cuenta_detalles.relator_id  || currentUser.id === cuenta_detalles.magistrado_id)"
                             :item="cuenta_detalles"
                             :apelacion="apelacion"
                             :role="roleUser"
                             @updateCuenta="updateCuenta($event)"
                           ></SubirResolucion>
                       </v-col>
                    </v-row>
                    <!--TERMINA COMPONENTE DE OBSERVACIONES DE COLEGIADA-->

               </div>
            </v-card-text>
         </v-card>
         <!--INICIA SECCION DE DOUCMENTOS-->
         <v-row>
            <v-col cols="12" md="12">
               <v-toolbar
                  class="mb-6"
                  color="#1D2E4B"
                  dark
               >
                  <v-toolbar-title class="text-uppercase">Documentos del Toca</v-toolbar-title>
                  <v-spacer></v-spacer>
               </v-toolbar>

               <v-card-text class="mt-6">
                  <div class="mx-auto" style="width: 90%;">
                     <v-row>
                        <v-col cols="12" md="12">
                           <p
                               class="font-weight-bold text-18 mb-2"
                               style="color:#616161"
                           >
                               DOCUMENTOS
                           </p>
                           <v-divider class="mt-2 mb-2" style="background-color:#D4B262">
                           </v-divider>
                       </v-col>
                     </v-row>
                  </div>
               </v-card-text>
               <ListDocumentos
                 v-if="cuenta_detalles && (roleUser == 'magistrado' || roleUser == 'relator')"
                 ref="documentos"
                 :cuenta="cuenta_detalles"
                 :apelacion="apelacion"
                 :role="roleUser"
                 @updateCuenta="updateCuenta($event)"
               ></ListDocumentos>
            </v-col>
         </v-row>
         <!--TERMINA SECCION DE DOCUMENTOS-->

        <!-- ARCHIVAR -->
        <div class="mx-auto" style="width: 90%;">
          <v-row class="mt-8"
            v-if="cuenta_detalles &&
                  cuenta_detalles.status==44 &&
                  (currentUser.id === cuenta_detalles.relator_id  ||
                  currentUser.id === cuenta_detalles.magistrado_id)
            "
           >
              <v-col cols="12" md="12">
                  <p
                      class=" font-weight-bold text-18 mb-2"
                      style="color:#616161"
                  >
                      ARCHIVAR

                  </p>
                  <v-divider inset class="mt-2 mb-2" style="background-color:#D4B262"></v-divider>
              </v-col>
          </v-row>
          <v-row
            v-if="cuenta_detalles &&
                  cuenta_detalles.status==44 &&
                  (currentUser.id === cuenta_detalles.relator_id  ||
                  currentUser.id === cuenta_detalles.magistrado_id)
            "
          >
              <v-col cols="12">
                <Archivar
                  v-if="cuenta_detalles && (roleUser == 'magistrado' || roleUser == 'relator')"
                 :cuenta="cuenta_detalles"
                 :apelacion="apelacion"
                 :role="roleUser"
                 @closeModal="$router.push({ name:'Tocas' })"
               >
               </Archivar>

              </v-col>
          </v-row>
        </div>

      </v-col>
  </v-row>
</template>

<script>
import DetallesApelacion from "../../components/DetallesApelacion";
import ApelacionElectronica from "@/components/ApelacionElectronica";
import ObservacionRelator from "../../components/ObservacionRelator";
import ObservacionMagistrado from "../../components/ObservacionMagistrado";
import ObservacionColegiada from "../../components/ObservacionColegiada";
import SubirResolucion from "../../components/SubirResolucion";
import ListDocumentos from "../../components/ListDocumentos";
import ColegiadaVotos from "../../components/ColegiadaVotos";
import Archivar from "../../components/Archivar";

import { mapGetters } from "vuex";

export default {
  components: {
      DetallesApelacion,
      ApelacionElectronica,
      ObservacionRelator,
      ObservacionMagistrado,
      ObservacionColegiada,
      // Sentido,
      SubirResolucion,
      ListDocumentos,
      Archivar,
      ColegiadaVotos,
  },
  metaInfo: {
      title: 'Detalles'
  },
  data(){
      return{
        apelacion: null,
        cuenta_detalles: null
      }
    },
    computed: {
      formTitle () {
        return 'Detalles'
      },
      ...mapGetters(["currentUser", "roleUser", "currentCuenta"]),
    },
    mounted() {
      this.cuenta_id = JSON.parse(localStorage.getItem("currentCuenta"))
      this.getCuenta()
    },
    methods:{
      getCuenta(){
        this.$store.dispatch("SHOW_CUENTA", {
          url:"/cuenta/"+ this.cuenta_id
        }).then((response) => {
          this.cuenta_detalles = response.data.data.cuenta
          this.apelacion = response.data.data.cuenta.apelacion
        }).catch(err => {
          console.log(err);
        });
      },
      updateCuenta (val){
        this.getCuenta()
        // this.cuenta_detalles.resolucion_proyecto = val
        this.$refs.documentos.getDocs();
      }
    }
}
</script>
